import type { JSX } from 'react';
import { useToastStore } from '@/state/toastStore';

/**
 * Toast host.
 *
 * `aria-live="polite"` so a save confirmation is announced without stealing
 * focus, and the container is `pointer-events: none` so toasts never intercept
 * a click meant for the screen behind them.
 */
export function Toasts(): JSX.Element {
  const toasts = useToastStore((s) => s.toasts);
  return (
    <div className="toast-wrap" aria-live="polite" aria-atomic="false">
      {toasts.map((t) => (
        <div key={t.id} className="toast">
          <div className="tt">{t.title}</div>
          {t.description !== undefined && <small>{t.description}</small>}
        </div>
      ))}
    </div>
  );
}
